import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'detectednotdetected' })
@Injectable()
export class DetectednotdetectedPipe implements PipeTransform {
  transform(value: any, arg0?: string, arg1?: string): any {
    let reverse = arg0 === 'rev' || arg1 === 'rev';
    let capitalize = arg0 === 'capitalize';

    let no = capitalize ? 'Not Detected' : 'not detected';
    let yes = capitalize ? 'Detected' : 'detected';

    if (typeof value === 'boolean') {
      if (reverse) {
        return value ? no : yes;
      } else {
        return value ? yes : no;
      }
    } else if (value === 'true') {
      return reverse ? no : yes;
    } else if (value === 'N/A' || value == null) {
      return 'N/A';
    } else {
      // false
      return reverse ? yes : no;
    }
  }
}
